import { parseAsInteger, useQueryState } from 'nuqs';
import { useMemo } from 'react';
import { parseAsMultiple } from '@/utils/parsers';
export default function useProductSearchParams() {
    const [inclusions, setInclusions] = useQueryState('inclusions', parseAsMultiple({ keyLabel: 'id', valueLabel: 'quantity', separator: ',' })(parseAsInteger).withDefault([]));
    const [activityDate, setActivityDate] = useQueryState('activity_date', {});
    const [participants, setParticipants] = useQueryState('participants', {});
    const productSearchParams = useMemo(() => ({
        inclusions,
        activityDate,
        participants,
    }), [inclusions, activityDate, participants]);
    return {
        productSearchParams,
        setInclusions,
        setActivityDate,
        setParticipants,
    };
}
